<template>
    <div>
        <NewItem ref="addNewTemplateDialog" @saveSuccess="queryList"></NewItem>
        <div style="display:flex;margin-top:10px;">
            <el-form ref="form" label-width="80px">
                <el-form-item label="工单编号">
                    <el-input v-model="no" style="width:100px;"></el-input>
                </el-form-item>
            </el-form>
            <el-form ref="form" label-width="80px">
                <el-form-item label="皮带流程">
                    <el-input v-model="beltId" style="width:100px;"></el-input>
                </el-form-item>
            </el-form>
            <el-date-picker
                style="margin-left:10px;"
                v-model="queryTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
            <el-button style="height:40px;margin-left:10px;" type="primary" @click="queryList">查询</el-button>
            <el-button style="height:40px;margin-left:10px;" type="primary" @click="exportExcel">导出</el-button>
        </div>
        <el-table :data="tableData" style="width: 100%; min-height:450px;">
            <el-table-column prop="no" label="工单编号"></el-table-column>
            <el-table-column prop="beginTime" :formatter="formatTime" label="开始时间"></el-table-column>
            <el-table-column prop="endTime" :formatter="formatTime" label="结束时间"></el-table-column>
            <el-table-column prop="endTime" :formatter="formatDuration" label="工单运行时间"></el-table-column>
            <el-table-column prop="energy" :formatter="formatEnergy" label="工单电耗"></el-table-column>
            <!-- <el-table-column prop="berthId" :formatter="formatBert" label="泊位"></el-table-column>
            <el-table-column prop="areaId" :formatter="formatArea" label="堆场"></el-table-column> -->
            <el-table-column prop="typeId" :formatter="formatType" label="操作量"></el-table-column>
            <el-table-column prop="dockDevNames" label="码头设备"></el-table-column>
            <el-table-column prop="belt" label="作业流程"></el-table-column>
            <el-table-column prop="pauseDuration" :formatter="formatPauseDuration" label="待机时间"></el-table-column>
            <el-table-column prop="efficiency" :formatter="formatEfficiency" label="能效"></el-table-column>
            <el-table-column prop="timeEfficency" label="时效"></el-table-column>
            <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                    <el-button type="primary" @click="detail(scope.row)">查看</el-button>
                </template>
            </el-table-column>
        </el-table>
        <center>
            <el-pagination
                @prev-click="prePage"
                @next-click="nextPage"
                @current-change="pageChange"
                :page-size="pageSize"
                :pager-count="10"
                layout="prev, pager, next"
                :total="total">
            </el-pagination>
        </center>
    </div>
</template>
<script>
import NewItem from './NewItem';
import XLSX from 'xlsx'
import toExcel from '../../../../components/js/toExcel';

export default {
    components:{
        NewItem
    },
    data(){
        return{
            no: '', 
            beltId: '',  
            berthId: '',  
            areaId: '',  
            queryTime: '',  
            beginTime: '',
            endTime:'',
            pageIndex:0,
            pageSize:10,
            pageCount:0,
            total:0,
            tableData: [],
            search: '',
            acceptList: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'],
            getFileInputKey:0,//用于让input在选中文件后重置
            excelData: [
                {
                    name: '张三',
                    birthday: new Date('1990-01-01'),
                    sex: '男',
                    age: 28
                },
                {
                    name: '李四',
                    birthday: new Date('1991-01-01'),
                    sex: '女',
                    age: 27
                }
            ]

        }
    },
    computed:{
        berthList(){
            return this.$store.ningboStore.getters.getBerthList;
        },
        areaList(){
            return this.$store.ningboStore.getters.getAreaList;
        },
        typeList(){
            return this.$store.ningboStore.getters.getTypeList;
        }
    },
    mounted(){
        var v = this.$store.ningboStore.commit("init")
        this.initList();
    },
    watch:{
        queryTime(nv, ov){
            try{
                this.beginTime = new Date(nv[0]).format('yyyy-MM-dd 00:00:00')
                this.endTime = new Date(nv[1]).format('yyyy-MM-dd 23:29:29')
            }catch(err){
                this.beginTime = '';
                this.endTime = ''
            }
        }
    },
    methods:{
        newItem(){
            this.$refs.addNewTemplateDialog.open()
        },
        updateItem(item){
            this.$refs.addNewTemplateDialog.title="编辑皮带流程"
            this.$refs.addNewTemplateDialog.id = item.id;
            this.$refs.addNewTemplateDialog.name = item.name;
            this.$refs.addNewTemplateDialog.remark = item.remark;
            this.$refs.addNewTemplateDialog.addTemplateShow=true
            //设置设备数据
        },
        deleteItem(item){
            console.log(item)
            this.$confirm('确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.deleteItemImpl(item.id);
            })
        },
        deleteItemImpl(id){
            this.$api.ningboApi.delWorkorder(id, response => {
                this.queryList();
                    this.$message({
                        type: 'success',
                        message: '删除成功'
                    });
                }, failure => {
                    this.$message({
                        type: 'error',
                        message: failure
                    });
                })
        },
        pauseItem(item){
            console.log(item)
            this.$confirm('确认暂停?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.pauseItemImpl(item.id);
            })
        },
        pauseItemImpl(id){
            this.$prompt('请输入事件', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                }).then(({ value }) => {
                    this.$api.ningboApi.pauseWorkorder(id, value, response => {
                        this.queryList();
                            this.$message({
                                type: 'success',
                                message: '工单已暂停'
                            });
                        }, failure => {
                            this.$message({
                                type: 'error',
                                message: failure
                            });
                        })
                });
        },
        restartItem(item){
            console.log(item)
            this.$confirm('确认重启?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.restartItemImpl(item.id);
            })
        },
        restartItemImpl(id){
            this.$api.ningboApi.restartWorkorder(id, response => {
                this.queryList();
                    this.$message({
                        type: 'success',
                        message: '工单已重启'
                    });
                }, failure => {
                    this.$message({
                        type: 'error',
                        message: failure
                    });
                })
        },
        closeItem(item){
            console.log(item)
            this.$confirm('确认关闭工单?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.closeItemImpl(item.id);
            })
        },
        closeItemImpl(id){
            this.$api.ningboApi.closeWorkorder(id, response => {
                this.queryList();
                this.$message({
                    type: 'success',
                    message: '工单已关闭'
                });
                }, failure => {
                    this.$message({
                        type: 'error',
                        message: failure
                    });
                })
        },
        initList(){
            this.$api.ningboApi.findAllHistoryWorkorder(this.no, this.beltId, this.beginTime, this.endTime, this.pageIndex, this.pageSize, response => {
                this.refreshData(response);
            })
        },
        queryList(){
            this.$api.ningboApi.findAllHistoryWorkorder(this.no, this.beltId, this.beginTime, this.endTime, this.pageIndex, this.pageSize, response => {
                this.refreshData(response);
            })
        },
        prePage(){
            // this.$api.ningboApi.findAllHistoryWorkorder(this.no, this.beltId, this.beginTime, this.endTime, this.pageIndex, this.pageSize, response => {
            //     this.refreshData(response);
            // })
        },
        nextPage(){
            // this.$api.ningboApi.findAllHistoryWorkorder(this.no, this.beltId, this.beginTime, this.endTime, this.pageIndex, this.pageSize, response => {
            //     this.refreshData(response);
            // })
        },
        pageChange(page){
            page = page - 1;
            this.$api.ningboApi.findAllHistoryWorkorder(this.no, this.beltId, this.beginTime, this.endTime, page, this.pageSize, response => {
                this.refreshData(response);
            })
        },
        refreshData(data){
            console.log(data)
            this.pageIndex = data.data.pageIndex;
            this.pageSize = data.data.pageSize;
            this.pageCount = data.data.pageCount;
            this.total = data.data.total;
            this.tableData = data.data.list;
        },
        test(){
        },
        exportExcel() {
            this.$api.ningboApi.findAllHistoryWorkorder(this.no, this.beltId, this.beginTime, this.endTime, -1, -1, response => {
                var uri = 'data:application/vnd.ms-excel;base64,'
                var template = '<html><head><meta charset="UTF-8"></head><body><table style="border:1px solid black; widht:100%;" border="1" cellspacing="0" cellpadding="0">{table}</table></body></html>'
                var base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
                var format = function(s, c) {
                    return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) 
                }
                var table = '<tr><td colspan="4" align="center">工单信息</td></tr>';
                table += '<tr><td colspan="4"></td>&nbsp;</tr>';

                //船名，取第一条数据
                var index = response.data.list[0]['no'].indexOf("_");
                var shipName = response.data.list[0]['no'];
                if(index != -1){
                    shipName = shipName.split("_")[0];
                }
                table += '<tr><td>船名：</td><td colspan="3">' + shipName + '</td></tr>';

                for(var row=0; row<response.data.list.length; row++){
                    var dockDevNames = response.data.list[row].dockDevNames
                    dockDevNames = dockDevNames ? dockDevNames : ''
                    var beginTime = new Date(response.data.list[row].beginTime).format('yyyy-MM-dd hh:mm:ss');
                    var endTime = new Date(response.data.list[row].endTime).format('yyyy-MM-dd hh:mm:ss');
                    var duration = this.formatDurationImpl(new Date(response.data.list[row].endTime).getTime() - new Date(response.data.list[row].beginTime).getTime())
                    var pauseDuration = this.formatDurationImpl(response.data.list[row].pauseDuration)
                    var typeNumber = this.formatType2(response.data.list[row].typeId, response.data.list[row].number)
                    table += '<tr><td colspan="4">&nbsp;</td></tr>';
                    table += '<tr><td>皮带流程</td><td>' + response.data.list[row].belt + '</td><td>工单编号</td><td>' + response.data.list[row].no + '</td></tr>';
                    table += '<tr><td>开始时间</td><td align="left">' + beginTime + '</td><td>运行时间</td><td>' + duration + '</td></tr>';
                    table += '<tr><td>结束时间</td><td align="left">' + endTime + '</td><td>待机时间</td><td>' + pauseDuration + '</td></tr>';
                    table += '<tr><td>工单电耗</td><td>' + response.data.list[row].energy + "KWH" + '</td><td>操作量</td><td>' + typeNumber + '</td></tr>';
                    table += '<tr><td>码头设备</td><td colspan="3">' + dockDevNames + '</td></tr>';
                    table += '<tr><td>能效</td><td align="left">' + response.data.list[row].efficiency + '</td><td>时效</td><td align="left">' + response.data.list[row].timeEfficency + '</td></tr>';
                    
                    for(var er=0; er<response.data.list[row].events.length; er++){
                        var item = response.data.list[row].events[er];
                        var itemCtx = '暂停时间:' + new Date(item.pauseTime).format('yyyy-MM-dd hh:mm:ss') + ',持续时间：' + this.formatDurationImpl(item.duration) + ',事件：' + item.event;
                        if(er == 0){
                            table += '<tr><td>工单事件</td><td colspan="3">' + itemCtx + '</td></tr>';
                        }else{
                            table += '<tr><td></td><td colspan="3">' + itemCtx + '</td></tr>';
                        }
                    }
                }

                var ctx = {worksheet:'Worksheet', table: table}
                var formated = format(template, ctx)
                var excel = uri + base64(formated)
                window.location.href = excel;
            })
            if(1==1){
                return;
            }
            this.$api.ningboApi.findAllHistoryWorkorder(this.no, this.beltId, this.beginTime, this.endTime, -1, -1, response => {
                const th = ['工单编号', '开始时间', '结束时间', '工单运行时间', '工单电耗', '操作量', '码头设备', '作业流程', '待机时间', '能耗效率']
                const filterVal = ['no', 'beginTime', 'endTime', 'duration', 'energy', 'type', 'dockDevNames', 'belt', 'pauseDuration', 'efficiency']
                for(var i=0; i<response.data.list.length; i++){
                    response.data.list[i].beginTime = new Date(response.data.list[i].beginTime).format('yyyy-MM-dd hh:mm:ss')
                    response.data.list[i].endTime = new Date(response.data.list[i].endTime).format('yyyy-MM-dd hh:mm:ss')
                    response.data.list[i].duration = this.formatDurationImpl(new Date(response.data.list[i].endTime).getTime() - new Date(response.data.list[i].beginTime).getTime())
                    response.data.list[i].energy += "KWH"

                    console.log(response.data.list[i])
                    response.data.list[i].pauseDuration = this.formatDurationImpl(response.data.list[i].pauseDuration);
                    // response.data.list[i].efficiency += response.data.list[i].efficiency + '%'

                    for(var j=0; j<this.typeList.length; j++){
                        if(this.typeList[j].id == response.data.list[i].typeId){
                            response.data.list[i].type = this.typeList[j].name + ':' + response.data.list[i].number + 'T';
                        }
                    }
                }
                const data = response.data.list.map(v => filterVal.map(k => v[k]))
                const [fileName, fileType, sheetName] = ['历史工单列表', 'xlsx', 'sheet1']
                toExcel({th, data, fileName, fileType, sheetName})
            })
        },
        getBerth(berthId){
            for(var i=0; i<this.berthList.length; i++){
                if(this.berthList[i].id == berthId){
                    return this.berthList[i].name;
                }
            }
            return berthId
        },
        getArea(areaId){
            for(var i=0; i<this.areaList.length; i++){
                if(this.areaList[i].id == areaId){
                    return this.areaList[i].name;
                }
            }
            return areaId
        },
        getType(typeId, number){
            for(var i=0; i<this.typeList.length; i++){
                if(this.typeList[i].id == typeId){
                    return this.typeList[i].name + ':' + number + 't';
                }
            }
            return typeId + ':' + number
        },
        formatTime (row, column) {
            return new Date(eval('row.' + column.property)).format('yyyy-MM-dd hh:mm:ss');
        },
        formatDuration(row, column){
            var duration = new Date(row.endTime).getTime() - new Date(row.beginTime).getTime();
            return this.formatDurationImpl(duration)
        },
        formatPauseDuration(row, column){
            var duration = row.pauseDuration;
            return this.formatDurationImpl(duration)
        },
        formatDurationImpl(duration){
            duration /= 1000;
            var day = parseInt(duration / (60 * 60 * 24));
            duration -= day * (60 * 60 * 24);
            var hour = parseInt(duration / (60 * 60));
            duration -= hour * (60 * 60);
            var minute = parseInt(duration / 60);
            var second = duration - minute * 60;

            var str = '';
            if(day > 0){
                str = day + '天'
            }
            str += hour + '小时' + minute + '分' + parseInt(second) + '秒'
            return str;
        },
        formatEnergy(row, column){
            return eval('row.' + column.property) + "KWH"
        },
        formatEfficiency(row, column){
            return eval('row.' + column.property) + "%"
        },
        formatBert(row, column){
            for(var i=0; i<this.berthList.length; i++){
                if(this.berthList[i].id == row.berthId){
                    return this.berthList[i].name;
                }
            }
            return row.berthId
        },
        formatArea(row, column){
            for(var i=0; i<this.areaList.length; i++){
                if(this.areaList[i].id == row.areaId){
                    return this.areaList[i].name;
                }
            }
            return row.areaId
        },
        formatType(row, column){
            for(var i=0; i<this.typeList.length; i++){
                if(this.typeList[i].id == row.typeId){
                    return this.typeList[i].name + ':' + row.number + 'T';
                }
            }
            return row.typeId + ':' + row.number
        },
        formatType2(type, number){
            for(var i=0; i<this.typeList.length; i++){
                if(this.typeList[i].id == type){
                    return this.typeList[i].name + ':' + number + 'T';
                }
            }
            return type + ':' + number
        },
        formatState(row, column){
            if(row.runState == 0){
                return '运行中'
            }else if(row.runState == 1){
                return '暂停'
            }else if(row.runState == 2){
                return '结束'
            }else{
                return 'N/A'
            }
        },
        detail(item){
            this.$store.ningboStore.commit("setWorkorder", item)
            this.$router.push('/ningboNewWorkorderDetail')
        }
    }
}
</script>